import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClassificacaoBadgeComponent } from './classificacao-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClassificacaoBadgeComponent
    ],
    exports: [
        ClassificacaoBadgeComponent
    ]
})
export class ClassificacaoBadgeModule { }
